import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-224019af"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block" }
const _hoisted_2 = { class: "EmoticonList" }
const _hoisted_3 = { style: {"height":"450px"} }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]

import { EmotionList } from '@/pinia/types/livechat';

import { Tooltip } from 'ant-design-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Emoji',
  emits: ['AppendInputValue', 'viewStatus'],
  setup(__props, { emit }) {

const aTooltip = Tooltip;


const ClickEmoticon = (index: number) => {
  emit('AppendInputValue', {
    key: EmotionList[index],
    content: `<img class="emoji" style="width: 22px;height:22px;margin-right:2px;" src="http://static.lighos.com/emoji/${
      index + 1
    }.png" alt="${EmotionList[index]}" />`,
  });
  emit('viewStatus', false);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(EmotionList), (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "PicItem",
            onClick: ($event: any) => (ClickEmoticon(i))
          }, [
            _createVNode(_unref(aTooltip), {
              placement: "bottom",
              mouseLeaveDelay: 0
            }, {
              title: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.replace(/[\#|\;|]/g, '')), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: 'http://static.lighos.com/emoji/' + (i + 1) + '.png'
                }, null, 8, _hoisted_5)
              ]),
              _: 2
            }, 1024)
          ], 8, _hoisted_4))
        }), 128))
      ])
    ])
  ]))
}
}

})